import { render, staticRenderFns } from "./MessagePreviewReplyBox.vue?vue&type=template&id=61d44dfe&scoped=true&"
import script from "./MessagePreviewReplyBox.vue?vue&type=script&lang=js&"
export * from "./MessagePreviewReplyBox.vue?vue&type=script&lang=js&"
import style0 from "./MessagePreviewReplyBox.vue?vue&type=style&index=0&id=61d44dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d44dfe",
  null
  
)

export default component.exports